import React from 'react';
import {useSystemLogsResults} from './systemLogsResultsHelper';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useResultsTableDropdownPosition, useToggle} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import DropdownContainer from '../../../components/core/dropdown/DropdownContainer';
import DropdownRow from '../../../components/core/dropdown/DropdownRow';
import SystemLogsFilterPane from '../../Filters/SystemLogsFilterPane';
import {helpContextPageUrl} from '../../../conf/Routes';

function SystemLogsResults() {
    
    const { t } = useTranslation();
    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [dropdownLeft] = useResultsTableDropdownPosition();
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);
    
    const {
        columns,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        tableContent,
        sortBasis,
        sortDirection,
        setSort,
        columnsWidths,
        setColumnsWidths,
        rowIdSelector,
        fetchNextPage,
        isFetching,
        isLastPage,
        isPageLoaded,
        filterObject,
        setFilterObject,
        freeTextSearch,
        reloadButtonOnClick,
        toExcelAction
    } = useSystemLogsResults();

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.systemLogsResults}>
            <div className="DrawResultsDiv">
                <div className="DrawResultsToolbar">
                    <SMCButton variant="ghost" icon="refresh" disabled={isFetching} onClick={reloadButtonOnClick}>{t('SMC_GEN_REFRESH')}</SMCButton>
                    <SMCButton icon="filter" variant="ghost" disabled={isFetching} onClick={toggleFilterPane}>{t('SMC_GEN_FILTER')}</SMCButton>
                    {!isFetching && <span style={{ position: 'relative', top: '1px' }}>| {t('SMC_GEN_SHOWING')} {tableContent ? tableContent.length : 0} {t('SMC_GEN_RESULTS')}</span>}
                </div>
                <DropdownContainer style={{ left: dropdownLeft, position: 'absolute' }}>
                    <DropdownRow text={t('SMC_GEN_EXCEL')} action={toExcelAction} />
                </DropdownContainer>
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    rowIdSelector={rowIdSelector}
                    hasCheckboxColumn={false}
                    isFilterOpen={isFilterPaneOpen}
                    filterElem={
                        <SystemLogsFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    allowRowWrap={true}
                />
            </div>
        </SMCPage>
    );
}

export default SystemLogsResults;